import { ObjectFieldsChecker } from "../../../../../tools/ObjectFieldsChecker";
import { LatestNewsDto } from "../../../../networking/data/responses/latestnews/LatestNewsDto";
import { LatestNewsItem } from "./LatestNewsItem";

export class LatestNews {
    public readonly durationInHours: number;
    public readonly items: Array<LatestNewsItem>;

    public constructor(dto: LatestNewsDto) {
        this.validateDto(dto);
        this.durationInHours = dto.durationInHours;
        this.items = dto.items?.map(item => new LatestNewsItem(item)) ?? [];
    }

    private validateDto(dto: LatestNewsDto): void {
        ObjectFieldsChecker.throwIfInvalidFields(dto, [
            "durationInHours"
        ]);
    }
}
